import React, { useState } from 'react';
import ResetPasswordForm from 'components/forms/ResetPasswordForm';
import { useRouter } from 'next/router';
import LoginForm from 'components/forms/LoginForm';

const SpremeniGeslo = () => {
    const [success, setSuccess] = useState(false);
    const { push } = useRouter();

    const { query } = useRouter();
    const token = query.token;

    return (
        <div className="container max-w-md mx-auto pt-12 pb-24">
            <h1 className="text-center mb-6">Nastavi novo geslo</h1>
            {!success && <ResetPasswordForm token={token?.toString()} onSuccess={() => setSuccess(true)} />}
            {success && (
                <>
                    <p className="text-center">
                        Geslo je bilo uspešno spremenjeno. <br />
                        Zdaj se lahko z novim geslom prijaviš spodaj.
                    </p>
                    <div className="mt-4">
                        <LoginForm onLoginSuccess={() => push('/profil')} />
                    </div>
                </>
            )}
        </div>
    );
};

export default SpremeniGeslo;
